import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "redux/actions/knowledgeCategoryActions";
import { Translate } from "react-redux-i18n";
import MiniLoader from "components/MiniLoader";
import * as actions_body from "redux/actions/knowledgeActions";

const List_ = (props) => {
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    React.useEffect(() => {
        if (props.list.length === 0) return;
        const active = props.list.find((c) => c.id === selectedIndex);
        if (!active) {
            const first = props.list[0];
            setSelectedIndex(first.id);
            if (props.onCategorySelect) {
                props.onCategorySelect(first.id);
            }
        }
    }, [props.list, selectedIndex, props.onCategorySelect]);

    const onClick = (item) => {
        if (!item || item.id == null) return;
        setSelectedIndex(item.id);
        if (props.onCategorySelect) {
            props.onCategorySelect(item.id);
        }
        props.loadBody({
            id: props.user_id,
            category_id: item.id
        }, props.token);
    };

    return (
        <aside className="knowledge-sidebar">
            <div className="knowledge-sidebar-scroll">
                <ul className="knowledge-category-list">
                    {props.list.map((item) => (
                        <li key={item.id}>
                            <button
                                type="button"
                                className={`knowledge-category-item${selectedIndex === item.id ? " is-active" : ""}`}
                                onClick={() => { onClick(item); }}
                            >
                                {item.title}
                            </button>
                        </li>
                    ))}
                </ul>
                {props.pageSize === 25 && (
                    props.loadingMore ? (
                        <MiniLoader />
                    ) : (
                        <div className="knowledge-load-more">
                            <button type="button" className="Link">
                                <Translate value="load_more" />
                            </button>
                        </div>
                    )
                )}
            </div>
        </aside>
    );
};

List_.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object,
    onCategorySelect: PropTypes.func,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.knowledgeCategory.list,
        loading: reducer.knowledgeCategory.loading,
        error: reducer.knowledgeCategory.error,
        pageCount: reducer.knowledgeCategory.page_count,
        pageSize: reducer.knowledgeCategory.page_size,
        loadingMore: reducer.knowledgeCategory.loadingMore,
    };
}

const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    loadBody: (params, token) =>
        dispatch(actions_body.loadList({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(List_);
